import { listFiles } from '@wix/ambassador-media-site-media-v1-file-descriptor/http';
import { SortOrder } from '@wix/ambassador-media-site-media-v1-file-descriptor/types';
import { MediaManagerApiBase } from '../MediaManagerApiBase';
import { getMediaTypesFromString } from './requestMappers/MediaType.mappers';
import { mapFiles } from './responseMappers/File.mappers';
const displayNameField = 'displayName';
const updatedDateField = 'updatedDate';
export class PlatformizedApi extends MediaManagerApiBase {
  constructor(settings) {
    super();
    this.settings = settings;
  }
  async listItems(folderId, params) {
    var _data$nextCursor;
    const {
      httpClient,
      source,
      rawNamespace
    } = this.settings;
    const {
      mediaType,
      paging,
      sort
    } = params;
    const mediaTypes = mediaType ? getMediaTypesFromString(mediaType) : [];
    const request = {
      parentFolderId: folderId,
      mediaTypes,
      private: Boolean(this.settings.rawNamespace),
      // private files should always be with some namespace
      paging: {
        limit: paging.size,
        cursor: paging.cursor
      },
      sort: {
        fieldName: sort.order === 'name' ? displayNameField : updatedDateField,
        order: sort.direction === 'asc' ? SortOrder.ASC : SortOrder.DESC
      },
      rawNamespace
    };
    const {
      data
    } = await httpClient.request(listFiles(request));
    const {
      files = []
    } = data;
    const mappedFiles = mapFiles(files, {
      source
    }, this.settings.onError);
    const cursor = ((_data$nextCursor = data.nextCursor) == null || (_data$nextCursor = _data$nextCursor.cursors) == null ? void 0 : _data$nextCursor.next) || null;
    return {
      data: mappedFiles,
      paging: {
        cursor
      }
    };
  }
}
//# sourceMappingURL=PlatformizedApi.js.map